import React, { useMemo } from 'react';
import { getSectionScaleValueByWindowWidth } from 'src/styles/functions/getAnimationContainerDefaultStyles';
import {
  FreeTrialFormAnimatedWrapper,
  MovingContainer,
  FreeTrialFormContainer,
  FreeTrialFormContent,
} from './FreeTrialForm.styles';
import useWindowResize from 'src/hooks/useWindowResize';
import IdealMemberFormGrid from 'src/molecules/Shared/2024_Q1_people_magic/IdealMemberFormGrid/IdealMemberFormGrid';
import TextureOverlay from 'src/molecules/Standard/Shared/TextureOverlay/TextureOverlay';
import PeopleExplorerBackground from 'src/molecules/Shared/2024_Q1_people_magic/PeopleExplorerBackground/PeopleExplorerBackground';

interface FreeTrialFormProps {
  mobile?: boolean;
  scale?: boolean;
  statsigEvent?: string | boolean;
}

const FreeTrialForm = ({ mobile, scale = true, statsigEvent }: FreeTrialFormProps): JSX.Element => {
  const { width: windowWidth, height: windowHeight } = useWindowResize();
  const currentScale = useMemo(
    () => (!scale ? 1 : getSectionScaleValueByWindowWidth(windowWidth, windowHeight)),
    [windowWidth, windowHeight, scale]
  );

  return (
    <FreeTrialFormAnimatedWrapper>
      <TextureOverlay />
      <PeopleExplorerBackground mobile={mobile} />
      <MovingContainer>
        <FreeTrialFormContainer currentScale={currentScale}>
          <FreeTrialFormContent>
            <IdealMemberFormGrid statsigEvent={statsigEvent} />
          </FreeTrialFormContent>
        </FreeTrialFormContainer>
      </MovingContainer>
    </FreeTrialFormAnimatedWrapper>
  );
};

export default FreeTrialForm;
